import React, { FC, FunctionComponent } from 'react';
import { FlexGrid, FlexGridColumn } from '../../../../../components/FlexGrid';
import { SvgComponentProps } from '../../../../../components/Icons/types';
import { gray } from '../../../../../components/Color';

type PublicJobDetailEmployerDataItemProps = {
	icon: FunctionComponent<React.PropsWithChildren<SvgComponentProps>>;
	value: string;
};

export const PublicJobDetailEmployerDataItem: FC<React.PropsWithChildren<PublicJobDetailEmployerDataItemProps>> = ({
	icon,
	value,
}) => {
	const Icon = icon;

	return (
		<FlexGrid gap='scanty'>
			<FlexGridColumn>{<Icon fill={gray[5]} />}</FlexGridColumn>
			<FlexGridColumn
				grow
				wrappedText
			>
				{value}
			</FlexGridColumn>
		</FlexGrid>
	);
};
